import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import { Button, Loader } from '@kanda-libs/ks-design-library';

import { selectors } from 'store';

import PropensioXidModal from './PropensioXidModal';
import { BUTTON_PROPS } from './constants';
import usePaymentOverrideButtons from './usePaymentOverrideButtons';

const PaymentOverrideButtons: FunctionComponent = function () {
  const isLoading = useSelector(selectors.getIsLoading);
  const {
    showAccept,
    showDecline,
    showCancel,
    showReferred,
    showCustomerAction,
    isSubmitting,
    acceptClick,
    declineClick,
    cancelClick,
    referredClick,
    customerActionClick,
    propensioCallback,
    setPropensioCallback,
    consentClick,
  } = usePaymentOverrideButtons();

  // if (showConsent)
  //   return (
  //     <>
  //       <Button.Text
  //         id="staff-request-consent"
  //         label="Send consent comms"
  //         disabled={isLoading || isSubmitting}
  //         isLoading={isLoading}
  //         onClick={consentClick}
  //         {...BUTTON_PROPS}
  //       />
  //       <Loader isLoading={isSubmitting} />
  //     </>
  //   );

  return (
    <>
      {showAccept && (
        <Button.Text
          id="staff-approve-finance"
          label="Approve Finance"
          disabled={isLoading || isSubmitting}
          isLoading={isLoading}
          onClick={acceptClick}
          {...BUTTON_PROPS}
        />
      )}
      {showDecline && (
        <Button.Text
          id="staff-decline-finance"
          label="Decline Finance"
          disabled={isLoading || isSubmitting}
          isLoading={isLoading}
          onClick={declineClick}
          {...BUTTON_PROPS}
        />
      )}
      {showCancel && (
        <Button.Text
          id="staff-cancel-finance"
          label="Cancel Finance"
          disabled={isLoading || isSubmitting}
          isLoading={isLoading}
          onClick={cancelClick}
          {...BUTTON_PROPS}
        />
      )}
      {showReferred && (
        <Button.Text
          id="staff-referred-finance"
          label="Refer Finance"
          disabled={isLoading || isSubmitting}
          isLoading={isLoading}
          onClick={referredClick}
          {...BUTTON_PROPS}
        />
      )}
      {showCustomerAction && (
        <Button.Text
          id="staff-customer-action-finance"
          label="Require customer action"
          disabled={isLoading || isSubmitting}
          isLoading={isLoading}
          onClick={customerActionClick}
          {...BUTTON_PROPS}
        />
      )}
      <Loader isLoading={isSubmitting} />
      <PropensioXidModal
        propensioCallback={propensioCallback}
        setPropensioCallback={setPropensioCallback}
      />
    </>
  );
};

export default PaymentOverrideButtons;
